jQuery(document).ready(function() {
    // Check if the URL contains 'code=abra47m'
    if (window.location.href.includes('code=abra47m')) {
        // Hide the element with the specified ID by setting display to none
        jQuery('.body-template-collection-preorder #shopify-section-template--24183775134017__countdown_3JwDjR').css('display', 'none');
        jQuery('.body-template-collection-preorder #shopify-section-template--24183775134017__countdown_PhjHyP').css('display', 'block');
        jQuery('.body-template-collection-preorder .section-template--24183775134017__product-grid-padding').css('display', 'block');
    }else
    {
      jQuery('.richtext__content.countdown__header-text p').after('<div class="klaviyo-form-WxMQUd"></div>');
    }

    jQuery('.image-banner__information.richtext__content.large-font').after('<div class="klaviyo-form-UCFB8v"></div>');

     
    // Define your desktop and mobile image URLs
    var desktopImg = "https://cdn.shopify.com/s/files/1/0812/7794/4129/files/Untitled_design_3.svg?v=1751258087";
    var mobileImg = "https://cdn.shopify.com/s/files/1/0812/7794/4129/files/47_MORNINGS2628.jpg?v=1749514884";

    // Select the image inside the slideshow (adjust selector if needed)
    var $heroImg = $(".slideshow-slide__img img");

    // Replace the image if on mobile
    if ($(window).width() < 768) {
      $heroImg.attr("src", mobileImg);
      $heroImg.attr("srcset", mobileImg);
    } else {
      $heroImg.attr("src", desktopImg);
      $heroImg.attr("srcset", desktopImg);
    }

    // Optional: Handle window resize (dynamic responsiveness)
    $(window).on("resize", function () {
      if ($(window).width() < 768) {
        $heroImg.attr("src", mobileImg);
        $heroImg.attr("srcset", mobileImg);
      } else {
        $heroImg.attr("src", desktopImg);
        $heroImg.attr("srcset", desktopImg);
      }
    });
         
});




